import { Colors, getAutomatedStyleProp, mediaQueries } from '@fourthwall/components';
import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column-reverse;
  min-height: calc(100vh - 96px);

  ${mediaQueries.tablet} {
    height: 600px;
    min-height: auto;
    flex-direction: row;
  }
`;
export const MainContent = styled.div `
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;

  ${mediaQueries.tablet} {
    padding: 28px;
    max-width: 430px;
    min-width: 430px;
  }
`;
export const SidebarContent = styled.div `
  flex: 1;
  display: flex;
  position: relative;
`;
export const HeaderContainer = styled.div `
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
`;
export const BackButton = styled.button `
  padding: 6px 4px 6px 8px;
  align-items: center;
  justify-content: center;
  display: flex;
  background: color-mix(in srgb, ${Colors.GS1000}, transparent 95%);

  &:hover {
    background: color-mix(in srgb, ${Colors.GS1000}, transparent 85%);
  }
`;
export const CloseButton = styled.button `
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
  cursor: pointer;

  display: block;
  padding: 6px;

  ${({ variant }) => variant === 'light' &&
    css `
      color: #fdfcfb;

      &:hover,
      &:focus {
        color: #cdccca;
        outline: none;
      }
    `}

  ${({ variant }) => variant === 'dark' &&
    css `
      color: ${getAutomatedStyleProp('colorOnBackground', Colors.GS600)};

      &:hover,
      &:focus {
        color: ${getAutomatedStyleProp('paleTextColor', Colors.GS1000)};
        outline: none;
      }
    `}
`;
